import React from 'react';
import './PrivacyPolicyPage.css';

export default function PrivacyPolicyPage() {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <h1 className="privacy-title">Política de Privacidade e Termos de Uso</h1>
        
        <div className="privacy-content">
          <p className="privacy-intro">
            Este site pertence e é operado por Barco de Papel - Academia de Criatividade. 
            Estes Termos estabelecem os termos e condições sob os quais você pode utilizar 
            nosso site e serviços oferecidos por nós. Este site oferece aos visitantes um 
            conjunto de informações e serviços sobre as atividades desenvolvidos pela 
            Academia de Criatividade. Ao acessar ou usar o website do nosso serviço, você 
            aprova que leu, entendeu e concorda em ficar vinculado a estes Termos.
          </p>

          <section className="privacy-section">
            <h2>Requisitos de Idade</h2>
            <p>
              Para usar nosso site e / ou receber nossos serviços, você deve ter pelo menos 
              16 anos de idade ou ter a idade legal de maioridade em sua jurisdição, e possuir 
              a autoridade legal, o direito e a liberdade de participar desses serviços. Você 
              não tem permissão para usar este website e / ou receber serviços se isso for 
              proibido em seu país ou sob qualquer lei ou regulamento aplicável a você.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Pagamentos e Taxas</h2>
            <p>
              A taxa pelos serviços e quaisquer outros encargos que você possa incorrer em 
              conexão com o uso do serviço, como impostos e possíveis taxas de transação, 
              serão cobrados mensalmente por sua forma de pagamento.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Política de Devolução</h2>
            <p>
              Para qualquer produto não danificado, basta devolvê-lo com seus acessórios 
              incluídos e embalagem junto com o recibo original (ou recibo de presente) 
              dentro de 14 dias da data de recebimento do produto, e nós trocaremos ou 
              ofereceremos um reembolso baseado no método de pagamento original.
            </p>
            <p>
              Além disso, observe o seguinte:
            </p>
            <ul>
              <li>Os produtos podem ser devolvidos apenas no país em que foram originalmente comprados</li>
              <li>Os seguintes produtos não são elegíveis para devolução: serviços com data expirada ou cartões oferta já utilizados</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>Alterações nos Serviços</h2>
            <p>
              Podemos, sem aviso prévio, alterar os serviços; deixar de fornecer os serviços 
              ou quaisquer recursos dos serviços que oferecemos; ou criar limites para os 
              serviços. Podemos rescindir ou suspender, permanentemente ou temporariamente, 
              o acesso aos serviços sem aviso prévio e responsabilidade por qualquer motivo 
              ou sem motivo.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Garantia</h2>
            <p>
              Quando recebermos uma reivindicação de garantia válida para um produto comprado 
              em nosso site, repararemos o defeito relevante ou substituiremos o produto. 
              Se não formos capazes de consertar ou substituir o produto dentro de um prazo 
              razoável, o cliente terá direito a um reembolso total após a devolução imediata 
              do produto para nós. Nós pagaremos pela remessa de produtos reparados ou 
              substituídos para o cliente e o cliente será responsável pela devolução do 
              produto para nós.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Rescisão</h2>
            <p>
              Podemos rescindir ou suspender permanentemente ou temporariamente seu acesso ao 
              serviço sem aviso prévio e responsabilidade por qualquer motivo, inclusive se, 
              em nossa única e exclusiva determinação, você violar qualquer disposição destes 
              Termos ou qualquer lei ou regulamentação aplicável. Você pode interromper o uso 
              e solicitar o cancelamento da sua conta e / ou de qualquer serviço a qualquer 
              momento. Não obstante qualquer disposição em contrário no que diz respeito a 
              assinaturas automaticamente renovadas de serviços pagos, tais assinaturas serão 
              descontinuadas somente após o término do respectivo período para o qual você já 
              efetuou pagamento.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Indenização</h2>
            <p>
              Você concorda em indenizar e isentar Barco de Papel - Academia de Criatividade 
              de quaisquer demandas, perdas, responsabilidades, reclamações ou despesas 
              (incluindo honorários advocatícios), feitas contra eles por qualquer terceiro 
              devido a, ou decorrentes de, ou em conexão com o uso do site ou qualquer um 
              dos serviços oferecidos no site.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Limitação de Responsabilidade</h2>
            <p>
              Na máxima extensão permitida pela lei aplicável, em nenhuma circunstância o 
              Barco de Papel - Academia de Criatividade será responsável por quaisquer danos 
              indiretos, punitivos, incidentais, especiais, consequenciais ou exemplares, 
              incluindo, sem limitação, danos por lucros cessantes, boa vontade, uso de dados 
              ou outras perdas intangíveis, decorrentes ou relacionadas ao uso ou incapacidade 
              de usar o serviço.
            </p>
            <p>
              Na extensão máxima permitida pela lei aplicável, não assumimos nenhuma 
              responsabilidade por quaisquer:
            </p>
            <ul>
              <li>Erros ou imprecisões de conteúdo</li>
              <li>Ferimentos pessoais ou danos materiais, de qualquer natureza, resultantes do seu acesso ou uso do nosso serviço</li>
              <li>Qualquer acesso não autorizado ou uso de nossos servidores seguros e / ou toda e qualquer informação pessoal armazenada nele</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>Comunicações Promocionais</h2>
            <p>
              Você concorda em receber de tempos em tempos mensagens promocionais e materiais 
              por correio, e-mail ou qualquer outro formulário de contato que você possa nos 
              fornecer (incluindo seu número de telefone para chamadas ou mensagens de texto). 
              Se você não deseja receber esses materiais promocionais ou avisos - por favor, 
              basta nos notificar a qualquer momento.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Lei Aplicável</h2>
            <p>
              Estes Termos, os direitos e recursos aqui previstos, e todas e quaisquer 
              reclamações e disputas relacionadas a ele e / ou aos serviços, serão regidos, 
              interpretados e aplicados em todos os aspectos única e exclusivamente de acordo 
              com as leis internas de Portugal, sem respeito aos seus conflitos de princípios 
              legais. Todas e quaisquer reclamações e disputas serão apresentadas, e você 
              consente que elas sejam decididas exclusivamente por um tribunal de jurisdição 
              competente localizado no Porto. A aplicação da Convenção das Nações Unidas de 
              Contratos para a Venda Internacional de Bens é expressamente excluída.
            </p>
          </section>

          <p className="privacy-date">Maio 2023</p>
        </div>
      </div>
    </div>
  );
}